import declare from "dojo/_base/declare";
import RefContainer from "csi/heading/RefContainer";
import _StyleAndColorwayMixin from "./_StyleAndColorwayMixin";

const ProductVersionStyleCandidates = declare([RefContainer, _StyleAndColorwayMixin], {
});

export = ProductVersionStyleCandidates;